import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const UsagePolicyPage = () => (
  <LegalPageLayout title="Usage Policy">
    <p className="text-white/60 text-sm">Last updated: {new Date().toLocaleDateString('en-US')}</p>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">1. Purpose</h2>
      <p>
        This Usage Policy defines acceptable use of Dial-Grid's platform and services. By using Dial-Grid, you agree to comply with this policy. Violations may result in suspension or termination of your account.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">2. Permitted Use</h2>
      <p>
        Dial-Grid is intended for legitimate business use by watch dealers and related professionals. You may use the platform to manage inventory, clients, sales, accounting, invoicing, and other business operations in accordance with applicable laws and regulations.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">3. Prohibited Activities</h2>
      <p>You may not:</p>
      <ul className="list-disc pl-6 mt-2 space-y-1">
        <li>Use the Service for any illegal purpose or in violation of any law</li>
        <li>List, sell, or facilitate the sale of counterfeit, stolen, or illegally obtained goods</li>
        <li>Harass, abuse, or harm other users or third parties</li>
        <li>Attempt to gain unauthorized access to our systems, other accounts, or data</li>
        <li>Transmit malware, spam, or other harmful content</li>
        <li>Resell, sublicense, or commercially exploit the Service without authorization</li>
        <li>Use automated tools (e.g., scrapers, bots) to access the Service except as permitted</li>
        <li>Circumvent security measures or usage limits</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">4. Compliance</h2>
      <p>
        Users are responsible for complying with all applicable laws, including those governing the sale of luxury goods, tax reporting (e.g., Form 8300, 1099), and consumer protection. Dial-Grid provides tools to assist with compliance but does not provide legal or tax advice.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">5. Enforcement</h2>
      <p>
        We may investigate suspected violations and take action including warnings, suspension, or termination of accounts. We may also report illegal activity to law enforcement. We reserve the right to modify this policy at any time.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">6. Contact</h2>
      <p>
        To report violations or ask questions about this policy, contact us at support@dial-grid.com.
      </p>
    </section>
  </LegalPageLayout>
);

export default UsagePolicyPage;
